export const DefaultFormsTypesEnum = {
  Offers: {
    key: 'fb-001',
  },
  Contacts: {
    key: 'fb-002',
  },
  DummyContacts: {
    key: 'fb-003',
  },
  Visa: {
    key: 'fb-004',
  },
  Flows: {
    key: 'fb-006',
    value: 'flows',
    isWithoutRecipientSwitch: true,
    isWithDelay: true,
  },
};
